var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 6"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 3,
    r: 3
  })))));
}

export default SvgLeader;